import {actionCreator} from "@core/mgx/actionCreator";

export const ACTION_CATEGORY = 'ONBOARDING';
const createAction = actionCreator(ACTION_CATEGORY);

export const [_UPLOAD_LIST, UPLOAD_LIST] = createAction('UPLOAD_LIST');
export const [_UPLOAD_LIST_FIN, UPLOAD_LIST_FIN] = createAction.async(_UPLOAD_LIST, true).fin;

// New: Partial upload of valid rows only
export const [_UPLOAD_PARTIAL, UPLOAD_PARTIAL] = createAction('UPLOAD_PARTIAL');
export const [_UPLOAD_PARTIAL_FIN, UPLOAD_PARTIAL_FIN] = createAction.async(_UPLOAD_PARTIAL, true).fin;
